/**
 * 📊 Módulo centralizado de Google Analytics 4 (GA4)
 * Measurement ID: G-352GMDCF8V
 * 
 * Todas as chamadas são protegidas por guard para evitar erros
 * quando o gtag não está carregado (ex: consentimento LGPD negado).
 */

const GA_MEASUREMENT_ID = "G-352GMDCF8V";

function safeGtag(...args: Parameters<NonNullable<typeof window.gtag>>) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

// ─── SPA Page View ───────────────────────────────────────────
export function trackPageView(title: string, path: string) {
  safeGtag("config", GA_MEASUREMENT_ID, {
    page_title: title,
    page_path: path,
  });
}

// ─── Funil: view_teacher_profile ─────────────────────────────
export function trackViewTeacherProfile(teacherId: string, teacherName: string) {
  safeGtag("event", "view_teacher_profile", {
    teacher_id: teacherId,
    teacher_name: teacherName,
  });
}

// ─── Funil: click_schedule_class ─────────────────────────────
export function trackClickScheduleClass(teacherName: string) {
  safeGtag("event", "click_schedule_class", {
    teacher_name: teacherName,
  });
}

// ─── Funil: checkout_success ─────────────────────────────────
export function trackCheckoutSuccess(value: number, currency = "BRL") {
  safeGtag("event", "checkout_success", {
    value,
    currency,
  });
}

// ─── Funil: b2b_lead_click ───────────────────────────────────
export function trackB2BLeadClick(source: string) {
  safeGtag("event", "b2b_lead_click", {
    source,
  });
}
